export const categories = [
  {
    key: "tv",
    name: "电视剧",
    desc: "汇集当下热门与经典电视剧集，涵盖古装、悬疑、都市、年代等多种题材，带你看遍屏幕里的百态人生。",
  },
  {
    key: "movie",
    name: "电影",
    desc: "精选院线与口碑电影作品，从科幻到文艺、从动作到剧情，为每一次观影提供可靠参考。",
  },
  {
    key: "classic",
    name: "经典影视",
    desc: "历久弥新的经典之作，值得反复品味的影视宝藏，陪你重温那些被时间验证过的好故事。",
  },
];

export const regions = [
  "全部",
  "中国大陆",
  "中国香港",
  "中国台湾",
  "美国",
  "韩国",
  "日本",
  "英国",
];

export const years = ["全部", "2025", "2024", "2023", "2022", "2021", "2020"];

export const genres = [
  "全部",
  "剧情",
  "爱情",
  "悬疑",
  "犯罪",
  "动作",
  "科幻",
  "奇幻",
  "古装",
  "武侠",
  "仙侠",
  "喜剧",
  "家庭",
  "青春",
  "谍战",
  "年代",
  "医疗",
];

export const sortOptions = [
  { key: "latest", name: "最新" },
  { key: "hot", name: "最热" },
  { key: "rating", name: "评分" },
];